// MGN YAEH "Choose Your Impact" cart widget interaction logic.
// Loaded on every page via cart-drawer.liquid. Uses document-level event
// delegation so clicks keep working even after Dawn's renderContents swaps
// the cart-drawer innerHTML (which would otherwise wipe event listeners).
(function () {
  if (window.__yaehImpactWired) return;
  window.__yaehImpactWired = true;

  var STORAGE_KEY = 'yaeh_impact_choice';

  function activate(root, cause) {
    if (!root || !cause) return;
    // Reveal the description card on the first selection. The class
    // persists for the rest of the session (and across reloads via the
    // restore() path), so once the customer has chosen, the card stays.
    root.classList.add('has-selection');
    root.querySelectorAll('.yaeh-impact-icon').forEach(function (i) {
      var on = i.dataset.cause === cause;
      i.classList.toggle('is-active', on);
      i.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-cause-panel]').forEach(function (p) {
      p.hidden = p.dataset.causePanel !== cause;
    });
    try {
      localStorage.setItem(STORAGE_KEY, cause);
    } catch (e) {}
    try {
      var root_path =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
        '/';
      fetch(root_path + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 'YAEH Impact Cause': cause },
        }),
      });
    } catch (e) {}
  }

  function restore() {
    var root = document.querySelector('[data-yaeh-impact]');
    if (!root) return;
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved) activate(root, saved);
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var icon = e.target.closest && e.target.closest('.yaeh-impact-icon');
    if (!icon) return;
    e.preventDefault();
    e.stopPropagation();
    var root = icon.closest('[data-yaeh-impact]');
    if (root) activate(root, icon.dataset.cause);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }

  function wireObserver() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      restore();
    }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireObserver);
  } else {
    wireObserver();
  }
})();
